<template>
	<v-container>
		<v-row>
			<v-col>
				<h2>
					Skills &amp; Experience
				</h2>
				<p>
					I'm a straight bad-ass, nough said.
				</p>

        <h2>
          The Nerdy details
        </h2>
        <p>
          My front-end work spans the MVC design pattern including Vue.js, jQuery, and Angular.js. I'm entralled with the psychology of UI/UX and take pride in creating visually pleasing and usable sites.
        </p>
        <p>
          Serverside work is mostly done using Node.js and I'm proficient in Python and have experience in datamining and machine learning.
        </p>
        <p>
          Data side I'm comfortable with both SQL and noSQL and have implemented both using mySQL, Oracle, mongoDB, Firebase, and various ORMs. I love the puzzle that data architecture presents, finding the right table schema to accurately represent the model is very satisfying to me.
        </p>
        <p>
          In my free time you can find me in my room reading, programming, and researching various emerging techs. I also like to get outside, I'm often seen wondering the deep woods of the Ozarks. I enjoy spelunking, rock climbing, cycling, kayak/canoing, backpacking, trail running, and other various outdoor activities.
        </p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	mounted() {
		window.scrollTo(0,0)
	}
}
</script>

<style scoped>

</style>